export class FirebaseConfig {
  apiKey!: string
  authDomain!: string
  projectId!: string
  storageBucket!: string
  messagingSenderId!: string
  appId!: string
  measurementId!: string
}
